import { render } from "./SessionTimeOutOTP.vue?vue&type=template&id=621e0d04&scoped=true"
import script from "./SessionTimeOutOTP.vue?vue&type=script&lang=js"
export * from "./SessionTimeOutOTP.vue?vue&type=script&lang=js"

import "./SessionTimeOutOTP.vue?vue&type=style&index=0&id=621e0d04&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-621e0d04"]])

export default __exports__